import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';

import { UserSettings } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, UserBeanService } from '@services';

export const userBeanReportingResolver: ResolveFn<
  Nullable<UserSettings>
> = async () => {
  const userBeanService = inject(UserBeanService);
  const router = inject(Router);
  const toastService = inject(ToastService);
  const translate = inject(TranslateService);

  const userBean = await userBeanService.getUserBean();
  const isUserAllowed =
    userBean.functions &&
    userBean.communityReporting &&
    userBean.communityPermission >= 3;

  if (!isUserAllowed) {
    toastService.show({
      text: translate.instant('WEB_NOTIFY_RESOURCE_DELETE_ERROR_403'),
      type: 'danger',
    });

    return new RedirectCommand(router.parseUrl('/home'));
  }

  return userBean;
};
